<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;AI Categories</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-circle-info me-1" style="color: #00A0C1;"></i>
                  Manage access to AI platforms and tools. <strong>Allow</strong>, <strong>Off</strong>, or <strong>Block</strong> each AI platform individually. This module will only work for Extension Version 4.0.0 and above on Firefox, Chrome, and Edge. <strong>Please note:</strong> It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.
               </small>
            </div>
         </div>
      </div>

      <AiCategories />
   </div>
</template>

<script>
import AiCategories from '@/components/ExtensionConfiguration/AiCategories/AiCategories.vue';

export default {

   components: {
      AiCategories,
   },

}
</script>

<style scoped>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}

.custom-span-no-weight {
   font-size: 24px;
   line-height: 24px;
   font-weight: 250;
}
</style>
